import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IAtgardBarighetChanged } from "~app/features/planera/model/IAtgardBarighetChanged";
import { IArbetsorderDetail, ISaveArbetsorderResponse } from "../planera-detail/planera-detail-models";
import { PlaneraService } from "./planera.service";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderSaveService {
    private readonly planeraService = inject(PlaneraService);
    private readonly busyService = inject(BusyService);

    save(arbetsorder: IArbetsorderDetail, atgardBarighetChanged: IAtgardBarighetChanged[] = null, showBusy = true): Observable<ISaveArbetsorderResponse> {
        const work = this.planeraService.saveArbetsorder({
            namn: arbetsorder.namn,
            arbetsorderId: arbetsorder.id,
            operationer: arbetsorder.operationer,
            handelssortiment: arbetsorder.handelssortiment,
            utbytesberakningar: arbetsorder.utbytesberakningar,
            kartgeometrier: arbetsorder.kartgeometrier,
            produktsatt: arbetsorder.produktsatt,
            raskVo: arbetsorder.raskVo,
            koordinaterVerifierade: arbetsorder.koordinaterVerifierade,
            commands: arbetsorder.commandManager.getAsJSon(),
            rowVersion: arbetsorder.rowVersion,
            updatedAtgardBarighet: atgardBarighetChanged
        });

        return showBusy ? this.busyService.addWork(work) : work;
    }
}
